import { render, staticRenderFns } from "./loginborrow.vue?vue&type=template&id=53a424be&scoped=true&"
import script from "./loginborrow.vue?vue&type=script&lang=js&"
export * from "./loginborrow.vue?vue&type=script&lang=js&"
import style0 from "./loginborrow.vue?vue&type=style&index=0&id=53a424be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a424be",
  null
  
)

export default component.exports